import { createBreakpoints } from '@mui/system';
var breakpoints = createBreakpoints({});
export var TableCellTheme = function (theme) {
    var _a;
    return ({
        defaultProps: {},
        styleOverrides: {
            root: (_a = {
                    borderColor: theme.palette.divider,
                    fontSize: theme.typography.body1.fontSize
                },
                _a[breakpoints.down('sm')] = {
                    fontSize: "0.813rem", //13
                },
                _a),
            sizeSmall: function (_a) {
                var theme = _a.theme;
                return ({
                    padding: theme.spacing(1, 1.5) // `8px 12px`
                });
            },
            sizeMedium: function (_a) {
                var theme = _a.theme;
                return ({
                    padding: theme.spacing(1.5) // `12px 12px`
                });
            },
            paddingCheckbox: function (_a) {
                var theme = _a.theme;
                return ({
                    paddingRight: theme.spacing(1),
                    '+ .MuiTableCell-root ': {
                        paddingLeft: 0
                    }
                });
            },
            head: function (_a) {
                var theme = _a.theme;
                return ({
                    paddingLeft: theme.spacing(1.5),
                    '&:first-of-type': {
                        '&[colspan]': {
                            paddingLeft: theme.spacing(1.5), //12,
                        }
                    }
                });
            },
            body: {
                fontWeight: "normal"
            }
        }
    });
};
export default TableCellTheme;
//# sourceMappingURL=theme.js.map